// блок с юзером в шапке1

import React, { useState, useEffect } from 'react';
import cl from './HeaderUser.module.css'
import { useLoader } from '../../../hooks/useLoader'
import UserService from '../../../API/UserService'
import { FOLDER_PROFILE } from '../../../API/API'
import ava from './img/avatar.png'
import img_rating from './img/1.png'
import img_almaz from './img/2.png'
import img_mesage from './img/3.png'
import img_notification from './img/4.png'
import { Link } from "react-router-dom";

import useStore from '../../../store/usersStore'


const HeaderUser = () => {

    const { user_profile, diamond, rating } = useStore();

    const [diamondState, setDiamondState] = useState(diamond); // обертка
    const [ratingState, setRatingState] = useState(rating); // обертка
    const [animateAlmaz, setAnimateAlmaz] = useState(false);
    const [animateRating, setAnimateRating] = useState(false);

    useEffect(() => {

        setDiamondState(diamond)
        setRatingState(rating)
    }, [diamond, rating])

    useEffect(() => {
        setAnimateAlmaz(true);
        const timer = setTimeout(() => setAnimateAlmaz(false), 500);
        return () => clearTimeout(timer);
    }, [diamond]);
    useEffect(() => {
        setAnimateRating(true);
        const timer = setTimeout(() => setAnimateRating(false), 500);
        return () => clearTimeout(timer);
    }, [diamond]);

    return (
        <div className={cl.HeaderUser_wrap}>
            <div className={cl.HeaderUser_left}>
                <div className={cl.avatarWrapper} style={{ position: 'relative', display: 'inline-block' }}>

                    <img
                        className={cl.HeaderUser_left_ava}
                        src={user_profile && user_profile.photo ? FOLDER_PROFILE + user_profile.photo : ava}
                        alt=""
                        style={{ position: 'relative', zIndex: 2 }}
                    />

                    {user_profile && user_profile.level > 0 && (
                        <img
                            src={`/rama/${user_profile.level}_rama.png`}
                            alt={`Рамка уровня ${user_profile.level}`}
                            className={cl.avatarFrame}
                            style={{
                                position: 'absolute',
                                top: -3,
                                left: -3,
                                width: '38px',
                                height: '38px',
                                zIndex: 3,
                                pointerEvents: 'none',
                            }}
                        />
                    )}
                </div>

                <div className={cl.HeaderUser_left_data}>
                    <h4>{user_profile && user_profile.firstName}</h4>
                    <p>Руководитель</p>
                </div>
            </div>
        </div>
    );
};

export default HeaderUser;
